import moment from "moment";

export const isOneWayBooking = booking => Number(booking?.isOneWay) === 1;

export function formatVehicleEventTime(info) {
  if (!isOneWayBooking(info.event.extendedProps)) return info.timeText;
  const start = info.event.start && moment(info.event.start);
  return start?.isValid() ? `${start.format("HH:mm")} • เที่ยวเดียว` : "เที่ยวเดียว";
}
